// @ai-generated 2026-07-03T18:45:00Z by dimitri.driediger@synqony.com using Claude Fable 5

export type RequisitionTerminMode = 'sofort' | 'wunsch';

export interface RequisitionWizardState {
    /** When true, the site step shows the picker (search + cards) instead of the collapsed selection card. */
    sitePicking: boolean;

    /** When true, the site is an unlinked snapshot created via the "Neue Anschrift anlegen" modal. */
    siteUseSnapshot: boolean;

    /** Which container of an exchange the customer opened for editing, where both would show as a summary. */
    exchangeEditing: 'pickup' | 'delivery' | undefined;

    /** "Schnellstmöglich" (no dates) vs. "Wunschtermin" (explicit dates). Default: sofort. */
    terminMode: RequisitionTerminMode;

    /** Whether the optional "spätestens bis" date field is expanded in Wunschtermin mode. */
    dateRangeExpanded: boolean;

    /**
     * Dates remembered when switching to "Schnellstmöglich" (which clears them on the draft),
     * so switching back to "Wunschtermin" restores them.
     */
    stashedDateFrom: string | undefined;
    stashedDateTo: string | undefined;

    /** AGB acceptance. Required before submit; not sent to the backend. */
    termsAccepted: boolean;
}

export const initialFeState: RequisitionWizardState = {
    sitePicking: true,
    siteUseSnapshot: false,
    exchangeEditing: undefined,
    terminMode: 'sofort',
    dateRangeExpanded: false,
    stashedDateFrom: undefined,
    stashedDateTo: undefined,
    termsAccepted: false,
};
